import { FormGroup, Text } from '@southfields-digital/mpxlive-components';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import Select from 'src/components/Select';
import { REQUEST_GET_DATA_PROVIDER_TRANSLATIONS } from 'src/redux/reducers/dataProviderTranslation';
import { REQUEST_GET_SPORT_DATA_TOURNAMENT_CALENDAR } from 'src/redux/reducers/sportData';

import Fixtures from './Fixtures';
import { HockeyLineup } from './HockeyLineup';
import Lineup from './Lineup';
import MatchStats from './MatchStats';
import styles from './SportData.module.scss';
import Standings from './Standings';
import HockeyStandings from './HockeyStandings';
import AskiDaLineup from './AskiDaLineup';
import { getCategory, getPropertyOptionsSportData } from './utils';

type Props = {
  selectedGraphic: PlaylistGraphic;
  onImport: (propertyId: string, value: string | PropertyValue[]) => void;
};

export default function SportData({ selectedGraphic, onImport }: Props) {
  const dispatch = useDispatch();
  const [property, setProperty] = useState<string>('');

  const selectedProperty = selectedGraphic.graphic.properties.find((p) => p.id === property);
  const category = getCategory(selectedGraphic.graphic.ref, selectedProperty);

  const handleImportStandings = (value: PropertyValue[]) => {
    if (!property) return;
    onImport(property, value);
  };
  const handleImportMatchStat = (value: string | PropertyValue[]) => {
    if (!property) return;
    onImport(property, value);
  };
  const handleImportFixtures = (value: PropertyValue[]) => {
    if (!property) return;
    onImport(property, value);
  };

  useEffect(() => {
    dispatch({ type: REQUEST_GET_SPORT_DATA_TOURNAMENT_CALENDAR });
    dispatch({ type: REQUEST_GET_DATA_PROVIDER_TRANSLATIONS });
  }, []);

  return (
    <div className={styles.Container}>
      <Text as="h2">Import Data</Text>
      <div className={styles.Content}>
        <FormGroup
          className={styles.InputProperties}
          htmlFor="selectedProperty"
          label="Selected property"
        >
          <Select
            id="selectedProperty"
            value={property}
            options={getPropertyOptionsSportData(
              selectedGraphic.graphic.ref,
              selectedGraphic.graphic.properties
            )}
            onChange={(e) => setProperty(e.currentTarget.value)}
          />
        </FormGroup>
        {category === 'Standings' && selectedProperty && (
          <Standings
            handleImportData={handleImportStandings}
            selectedGraphic={selectedGraphic}
            selectedProperty={selectedProperty as RepeaterProperties}
          />
        )}
        {category === 'Fixtures' && selectedProperty && (
          <Fixtures
            handleImportData={handleImportFixtures}
            selectedGraphic={selectedGraphic}
            selectedProperty={selectedProperty as RepeaterProperties}
          />
        )}
        {category === 'Lineup' && (
          <Lineup
            handleImportData={handleImportFixtures}
            selectedGraphic={selectedGraphic}
            selectedProperty={selectedProperty as RepeaterProperties}
          />
        )}
        {category === 'HockeyLineup' && (
          <HockeyLineup
            handleImportData={handleImportFixtures}
            selectedGraphic={selectedGraphic}
            selectedProperty={selectedProperty as RepeaterProperties}
          />
        )}
        {category === 'HockeyStandings' && (
          <HockeyStandings
            handleImportData={handleImportStandings}
            selectedProperty={selectedProperty as RepeaterProperties}
          />
        )}
        {category === 'Statistics' && (
          <MatchStats
            handleImportData={handleImportMatchStat}
            selectedProperty={selectedProperty}
          />
        )}
        {category === 'AskiDaLineup' && (
          <AskiDaLineup
            handleImportData={handleImportFixtures}
            selectedGraphic={selectedGraphic}
            selectedProperty={selectedProperty as RepeaterProperties}
          />
        )}
      </div>
    </div>
  );
}
